import { Component, OnInit, Injectable } from '@angular/core';
import { Router } from '@angular/router'
import { AuthService } from 'src/app/services/auth.service';

import { faDoorOpen } from '@fortawesome/free-solid-svg-icons'
import { MenuService } from 'src/app/services/menu.service';
import { MatDialog } from '@angular/material/dialog';
import { SelectionDialog } from '../../utils/group-selection/selection.component';
import { GroupsService } from 'src/app/services/groups.service';
import { UserService } from 'src/app/services/user.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  title = 'Dedalus';
  //exit = faDoorOpen;+
  public route: Router;
  sideNav: Function;
  group;
  groupType;
  user;
  configurationGroupProperty;

  constructor(private router: Router,
    private auth: AuthService,
    private menu: MenuService,
    public dialog: MatDialog,
    private groupsService: GroupsService,
    private userService: UserService) {
    this.route = this.router;
    this.sideNav = null;
    this.user = JSON.parse(localStorage.getItem('userS'));

  }
  ngOnInit(): void {

  }


  toggleSideNav() {
    this.menu.toggleMenu();
  }


  public isCollapsed = true;

  toggleMenu() {
    this.isCollapsed = !this.isCollapsed;
  }

  logout() {
    this.auth.logout();
    this.auth.authUpdate();
  }

  isAllowed(role: string) {
    if (this.auth == undefined) {
      return false;
    }
    else {
      return this.auth.hasAuthority(role);
    }
  }

  selectGroup(group) {
    localStorage.setItem(this.groupType, JSON.stringify(group))

    this.userService.setActiveGroup(this.groupType, group.id)
    //this.groupsService.changeGroup(group, this.groupType);   
  }

  groups = new Array();

  canChange;

  showGroupList() {
    let url = this.router.url.split("/");

    this.groupType = url[1];
    if (url[2]) {
      this.canChange = url[2].split(';')[0] == "edit-order";
    } else {
      this.canChange = false;
    }

    if (this.groupType != "")
      this.group = this.userService.getActiveGroup(this.groupType);

    return this.groupType != "" && this.group;

    // && JSON.parse(localStorage.get("user")).groups[this.router.url.split("/")[1]].length > 1;
  }

  openMenu() {
    this.user = JSON.parse(localStorage.getItem('userS'))
    this.groups = this.user.groups[this.groupType];
  }

 getConfigurationGroupProperties() {

    this.groupsService.getProperties('configuration', this.userService.getUser().groups.configuration[0].id).subscribe(
      (resp) => {
        this.configurationGroupProperty = resp;
      }
    )

  }

}


